module.exports = __webpack_public_path__ + "img/notif-added.6ecdc9f2.svg";